/* Bellary — „Zuletzt angesehen". Runde 69 (12.9.2026).

   Vorbild: Edikteds „Recently Viewed" unter dem Produkt.

   ⚠️⚠️ WARUM GEFILTERT UND NICHT NACHGELADEN.
   Die Sektion `zuletzt_angesehen` in templates/product.json laedt die
   automatische Kollektion „neuheiten" (Regel VARIANT_PRICE > 0, enthaelt
   jedes Produkt des Ladens) und liefert damit ALLE Karten mit. Dieses Skript
   blendet daraus genau die ein, die die Besucherin wirklich angesehen hat.
   Der Weg ueber die Section Rendering API waere sauberer, geht hier aber
   nicht: Horizons Karten sind aus Bloecken komponiert
   (`_product-card` mit Kindbloecken), und
   `sections/section-rendering-product-card.liquid` liefert bewusst ein
   reduziertes Kaertchen ohne Bild — gemessen 4021 B, kein <img>. Eine so
   nachgeladene Karte haette nicht dieselbe Gestalt wie die im Karussell
   „Passt dazu" daneben.

   ⚠️⚠️ DIE SEKTION IST STANDARDMAESSIG UNSICHTBAR (CSS: `display: none`,
   aufgehoben durch `data-bellary-zuletzt="bereit"`). Ohne JavaScript bleibt
   sie leer. Das ist Absicht: eine Ueberschrift „Zuletzt angesehen" ueber
   beliebigen Produkten waere eine falsche Aussage.

   ⚠️ Das aktuelle Produkt wird NICHT gezeigt — man sieht es ja gerade.
   ⚠️ Erst ab EINEM anderen Produkt erscheint die Sektion. Beim ersten
   Seitenbesuch im Laden gibt es also nichts, und das ist richtig.
   ⚠️ Gespeichert werden nur Handles, keine Namen, keine Preise, kein
   Zeitstempel — nichts, was ueber die Person Auskunft gibt. Reine
   Browser-Speicherung wie die Merkliste (bellary-wunschliste.js).
*/
(function () {
  'use strict';

  var SCHLUESSEL = 'bellary_zuletzt';
  var MAX = 12;
  /* ⚠️ Hoechstens vier Karten — eine Rasterreihe. Edikted zeigt 4,2 in einem
     scrollbaren Karussell; bei uns ist es ein Raster (Begruendung in
     templates/product.json), und eine zweite halbe Reihe waere kein
     „weiter geht es", sondern nur eine Luecke. */
  var ZEIGEN = 4;

  function lesen() {
    try {
      var roh = window.localStorage.getItem(SCHLUESSEL);
      var liste = roh ? JSON.parse(roh) : [];
      return Array.isArray(liste) ? liste.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      /* Privates Fenster, gesperrte Speicherung: dann eben ohne. */
      return [];
    }
  }

  function schreiben(liste) {
    try {
      window.localStorage.setItem(SCHLUESSEL, JSON.stringify(liste.slice(0, MAX)));
    } catch (e) {
      /* bewusst still */
    }
  }

  /* Handle aus einer Produkt-URL: /products/<handle> oder /en/products/<handle> */
  function handleAus(pfad) {
    var t = String(pfad || '').split('?')[0].split('#')[0].split('/products/');
    if (t.length < 2) return null;
    var h = t[1].split('/')[0];
    return h || null;
  }

  function merken() {
    var aktuell = handleAus(window.location.pathname);
    if (!aktuell) return null;
    var liste = lesen().filter(function (h) { return h !== aktuell; });
    liste.unshift(aktuell);
    schreiben(liste);
    return aktuell;
  }

  function aufbauen(aktuell) {
    var sektion = document.querySelector('[id*="__zuletzt_angesehen"]');
    if (!sektion) return;

    /* ⚠️ Die Karten sind `.resource-list__item`, NICHT <li>. Der erste
       Entwurf hat auf 'li' gesucht und live 0 Treffer gehabt, obwohl elf
       Karten im DOM standen (gemessen: li=0, .resource-list__item=11).
       Horizons Karussell rendert <div>s in einer <slideshow-container>.
       'li' bleibt als Rueckfall drin, falls das Markup zurueckwechselt. */
    var karten = sektion.querySelectorAll('.resource-list__item, li');
    if (!karten.length) return;

    var reihenfolge = lesen().filter(function (h) { return h !== aktuell; });
    var nachHandle = {};

    Array.prototype.forEach.call(karten, function (li) {
      var a = li.querySelector('a[href*="/products/"]');
      var h = a ? handleAus(a.getAttribute('href')) : null;
      li.hidden = true;
      if (h && !nachHandle[h]) nachHandle[h] = li;
    });

    var eltern = karten[0].parentElement;
    var gezeigt = 0;

    reihenfolge.forEach(function (h) {
      if (gezeigt >= ZEIGEN) return;
      var li = nachHandle[h];
      if (!li) return;
      li.hidden = false;
      /* Reihenfolge der Speicherung durchsetzen: das jeweils naechste Element
         wandert ans Ende der bereits sichtbaren. */
      eltern.appendChild(li);
      gezeigt++;
    });

    if (gezeigt > 0) {
      sektion.setAttribute('data-bellary-zuletzt', 'bereit');
    }
  }

  function start() {
    var aktuell = merken();
    aufbauen(aktuell);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
